import { observer } from 'mobx-react-lite'
import { BulkDuplicateBundleDialog } from '@/features/admin/bundle/BulkDuplicateBundleDialog'
import { BundleFormWorkspaceDropdownContainer } from '@/features/admin/bundle/components/BundleFormWorkspaceDropdown/BundleFormWorkspaceDropdownContainer'
import { type BulkDuplicateBundleDialogViewModel } from './BulkDuplicateBundleDialogViewModel'

export interface BulkDuplicateBundleDialogContainerProps {
  vm: BulkDuplicateBundleDialogViewModel
}

export const BulkDuplicateBundleDialogContainer = observer(
  function BulkDuplicateBundleDialogContainer({
    vm,
  }: BulkDuplicateBundleDialogContainerProps) {
    return (
      <BulkDuplicateBundleDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        selectedBundlesCount={vm.selectedBundles.length}
        workspaceDropdown={
          <BundleFormWorkspaceDropdownContainer
            vm={vm}
            workspaceSelectorVm={vm.workspaceSelectorVm}
            label="Target workspace"
            testId="bundle-modal-workspace"
          />
        }
        incompatibleBundles={vm.incompatibleBundleList.map((bundle) => ({
          id: bundle.id,
          name: bundle.name,
          description: bundle.description,
          baseItemName: bundle.baseItem.name,
        }))}
        partiallyCompatibleBundles={vm.partiallyCompatibleBundleList.map(
          (bundle) => ({
            id: bundle.id,
            name: bundle.name,
            description: bundle.description,
            baseItemName: bundle.baseItem.name,
            incompatibleItemNames: vm
              .getIncompatibleItems(bundle)
              .map((item) => item.name),
          }),
        )}
        compatibleBundlesCount={vm.compatibleBundles.length}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
        // Copied from the user-management removal dialog, so the rendered value
        // stays as it was even though nothing selects it here.
        submitButtonTestId="user-management-remove-from-workspace-remove-button"
      />
    )
  },
)
